import { startPerformanceCollection } from '@/lib/performance';
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from '@/App.jsx'
import '@/index.css'
import '@/native.css'
import '@/branding.css'
import '@/dark.css'
import { isAppLayout } from '@/lib/native'

startPerformanceCollection();

document.documentElement.classList.toggle('native-app', isAppLayout());

const GLITCHTIP_DSN = import.meta.env.VITE_GLITCHTIP_DSN;
if (GLITCHTIP_DSN) {
  Sentry.init({
    dsn: GLITCHTIP_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    window.parent?.postMessage({ type: 'sandbox:beforeUpdate' }, '*');
  });
  import.meta.hot.on('vite:afterUpdate', () => {
    window.parent?.postMessage({ type: 'sandbox:afterUpdate' }, '*');
  });
}



